import { Box } from '@wix/design-system';
import _ from 'lodash';
import { FC, useState } from 'react';
import { useProfileContext } from '../../Contexts/ProfileContext';
import ServiceAccordion from './components/ServiceAccordion';
import SingleCategoryMobileServices from './components/SingleCategoryMobileServices';

const StartingRatesMobile: FC = () => {
  const { offeredServices } = useProfileContext();
  const [openAccordions, setOpenAccordions] = useState<number[]>([0]);

  if (!offeredServices || _.size(offeredServices) === 0) {
    return null;
  }

  const hasOnlyOneCategory = _.size(offeredServices) === 1;

  const handleAccordionToggle = (index: number) => {
    setOpenAccordions((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index],
    );
  };

  return (
    <Box
      direction="vertical"
      dataHook="mobile-starting-rates"
      paddingRight="6px"
      paddingLeft="6px"
    >
      {hasOnlyOneCategory ? (
        <Box direction="vertical" paddingTop="18px">
          <SingleCategoryMobileServices
            services={_.head(offeredServices)?.services || []}
          />
        </Box>
      ) : (
        <ServiceAccordion
          offeredServices={offeredServices || []}
          openAccordions={openAccordions}
          onAccordionToggle={handleAccordionToggle}
        />
      )}
    </Box>
  );
};

export default StartingRatesMobile;
